const ATTACHMENT_MARKER_PREFIX = '[[attachment:';
const ATTACHMENTS_MARKER_PREFIX = '[[attachments:';
const MARKER_SUFFIX = ']]';
const HIDDEN_SUPPORT_METADATA_PATTERNS = [
  /^auth\s*provider\s*:/i,
  /^re-?auth\s*check\s*:/i,
  /^reauth\s*mode\s*:/i,
  /^request\s*type\s*:/i,
];

// Accepts a single attachment object or array of attachment objects
export const serializeSupportMessageContent = (text, attachments = null) => {
  const normalizedText = (text || '').trim();
  const list = Array.isArray(attachments)
    ? attachments.filter(a => a?.url)
    : (attachments?.url ? [attachments] : []);
  if (list.length === 0) return normalizedText;
  return `${normalizedText}\n\n${ATTACHMENTS_MARKER_PREFIX}${JSON.stringify(list)}${MARKER_SUFFIX}`;
};

// Returns { text, attachments: [...], attachment: first|null } — backward-compatible
export const parseSupportMessageContent = (content) => {
  const s = content || '';

  // New multi-attachment format
  const newStart = s.lastIndexOf(ATTACHMENTS_MARKER_PREFIX);
  if (newStart !== -1) {
    const newEnd = s.lastIndexOf(MARKER_SUFFIX);
    if (newEnd > newStart) {
      try {
        const attachments = JSON.parse(s.slice(newStart + ATTACHMENTS_MARKER_PREFIX.length, newEnd));
        const list = Array.isArray(attachments) ? attachments : [attachments];
        return { text: s.slice(0, newStart).trimEnd(), attachments: list, attachment: list[0] || null };
      } catch { /* fall through */ }
    }
  }

  // Old single-attachment format
  const oldStart = s.lastIndexOf(ATTACHMENT_MARKER_PREFIX);
  if (oldStart !== -1) {
    const oldEnd = s.lastIndexOf(MARKER_SUFFIX);
    if (oldEnd > oldStart) {
      try {
        const attachment = JSON.parse(s.slice(oldStart + ATTACHMENT_MARKER_PREFIX.length, oldEnd));
        return { text: s.slice(0, oldStart).trimEnd(), attachments: [attachment], attachment };
      } catch { /* fall through */ }
    }
  }

  return { text: s, attachments: [], attachment: null };
};

export const sanitizeSupportMessageText = (text = '') => {
  const lines = String(text || '').split(/\r?\n/);
  const visibleLines = lines.filter((line) => {
    const trimmed = line.trim();
    return trimmed ? !HIDDEN_SUPPORT_METADATA_PATTERNS.some((pattern) => pattern.test(trimmed)) : true;
  });
  return visibleLines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
};
